import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import { Message as Message$2, MessageTop, MessageTopContent, Header, HeaderContent, MessageBody } from './style.js';
import texts from './Message.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import Icon from '../Icon/Icon.js';
import Link from '../Link/Link.js';
import { ICON_UI_CIRCLE_INFO } from '../../icons/ICON_UI_CIRCLE_INFO.js';
import { ICON_UI_WARNING } from '../../icons/ICON_UI_WARNING.js';
import { ICON_UI_CHECKMARK_CIRCLE } from '../../icons/ICON_UI_CHECKMARK_CIRCLE.js';
import { ICON_TRAVEL_FLIGHT_DEPARTURE } from '../../icons/ICON_TRAVEL_FLIGHT_DEPARTURE.js';
import { ICON_UI_CHEVRON_UP } from '../../icons/ICON_UI_CHEVRON_UP.js';
import { ICON_UI_CHEVRON_DOWN } from '../../icons/ICON_UI_CHEVRON_DOWN.js';

var _excluded = ["className", "header", "children", "expandable", "initiallyExpanded", "showMessageBodyPreview", "link", "linkText", "messageType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var messageTypeIcons = {
  info: ICON_UI_CIRCLE_INFO,
  error: ICON_UI_WARNING,
  alert: ICON_UI_CIRCLE_INFO,
  success: ICON_UI_CHECKMARK_CIRCLE,
  travelInfo: ICON_TRAVEL_FLIGHT_DEPARTURE
};
function getMessageBodyDisplayType(_ref) {
  var expandable = _ref.expandable,
    expanded = _ref.expanded,
    showMessageBodyPreview = _ref.showMessageBodyPreview;
  if (!expandable) {
    return 'hidden';
  }
  if (expanded) {
    return 'show-full';
  }
  return showMessageBodyPreview ? 'show-ellipsis' : 'hidden';
}
var Message = function Message(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? null : _ref2$className,
    header = _ref2.header,
    _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? null : _ref2$children,
    _ref2$expandable = _ref2.expandable,
    expandable = _ref2$expandable === void 0 ? false : _ref2$expandable,
    _ref2$initiallyExpand = _ref2.initiallyExpanded,
    initiallyExpanded = _ref2$initiallyExpand === void 0 ? false : _ref2$initiallyExpand,
    _ref2$showMessageBody = _ref2.showMessageBodyPreview,
    showMessageBodyPreview = _ref2$showMessageBody === void 0 ? false : _ref2$showMessageBody,
    _ref2$link = _ref2.link,
    link = _ref2$link === void 0 ? null : _ref2$link,
    _ref2$linkText = _ref2.linkText,
    linkText = _ref2$linkText === void 0 ? null : _ref2$linkText,
    _ref2$messageType = _ref2.messageType,
    messageType = _ref2$messageType === void 0 ? 'info' : _ref2$messageType,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var _useState = useState(expandable && initiallyExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  if (typeof header !== 'string' || !header) {
    return undefined;
  }
  var expandIconPath = expanded ? ICON_UI_CHEVRON_UP : ICON_UI_CHEVRON_DOWN;
  var expandableWithChildren = children && expandable;
  var messageTopProps = expandableWithChildren ? {
    as: 'button',
    type: 'button',
    'aria-label': texts[culture].expandableAriaLabel,
    'aria-expanded': expanded,
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  } : {
    as: 'div'
  };
  var messageBodyDisplayType = getMessageBodyDisplayType({
    expandable: expandable,
    expanded: expanded,
    showMessageBodyPreview: showMessageBodyPreview
  });
  return (
    /*#__PURE__*/
    // @ts-expect-error
    jsxs(Message$2, _objectSpread(_objectSpread({
      className: className,
      $messageType: messageType
    }, rest), {}, {
      children: [/*#__PURE__*/jsxs(MessageTop, _objectSpread(_objectSpread({}, messageTopProps), {}, {
        // @ts-expect-error
        $messageBodyDisplayType: messageBodyDisplayType,
        $expandable: expandableWithChildren,
        $messageType: messageType,
        children: [/*#__PURE__*/jsx(Icon, {
          path: messageTypeIcons[messageType],
          "aria-hidden": "true",
          className: "sg-message-type-icon",
          size: messageType === 'travelInfo' ? 'm' : 's'
        }), /*#__PURE__*/jsx(MessageTopContent, {
          children: /*#__PURE__*/jsxs(Header, {
            // @ts-expect-error
            $messageType: messageType,
            $expandable: expandableWithChildren,
            children: [/*#__PURE__*/jsx(HeaderContent, {
              // @ts-expect-error
              $withSubtext: children,
              $expandable: expandableWithChildren,
              $messageType: messageType,
              children: header
            }), expandableWithChildren && /*#__PURE__*/jsx(Icon, {
              "aria-hidden": "true",
              path: expandIconPath,
              size: "xs"
            })]
          })
        })]
      })), children && /*#__PURE__*/jsxs(MessageBody, {
        // @ts-expect-error
        $messageType: messageType,
        $messageBodyDisplayType: messageBodyDisplayType,
        children: [children, link && linkText && /*#__PURE__*/jsx(Link, {
          href: link
          // @ts-expect-error
          ,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "message__link",
          children: linkText
        })]
      })]
    }))
  );
};
var Message$1 = Message;

export { Message$1 as default };
//# sourceMappingURL=Message.js.map
